import React from 'react';
import { Switch } from 'antd';
import type { WidgetProps } from '../registry';

export const SimpleSwitchWidget: React.FC<WidgetProps> = ({
  widget,
  onChange,
  error,
  warning,
}) => {
  return (
    <div className="rul-widget-field">
      {widget.label && (
        <label className="rul-widget-field-label">
          {widget.label}
          {widget.required && <span className="required">*</span>}
        </label>
      )}
      <Switch
        checked={widget.value || false}
        onChange={(checked) => onChange?.(widget.name, checked)}
        disabled={widget.disabled}
      />
      {error && <div className="rul-widget-error">{error}</div>}
      {warning && !error && <div className="rul-widget-warning">{warning}</div>}
    </div>
  );
};
